// client/src/utils/splitQuestion.ts
//
// MIRRORED FILE — twin of src/utils/splitQuestion.js (BUSINESS_RULES#vendor-invoice-split).
// When the split question shows on the review screen, and when Confirm & sync waits for
// it; the server refuses the same (SPLIT_QUESTION_UNANSWERED).

export function splitQuestionOpen(
  proposal: { status?: string | null; invoices?: unknown[] | null } | null | undefined
): boolean {
  const status = proposal?.status;
  return (status === 'pending' || status === 'declined') && (proposal?.invoices || []).length >= 2;
}
